// components/Hero.js
import React from "react";
import "./Hero.css";

const Hero = () => {
	return (
		<section className="hero">
			<div className="hero-content">
				<h1 className="hero-title">The MIT Post</h1>
				<p className="hero-subtitle">
					<i>The official student media of MIT, Manipal</i>
				</p>
			</div>
		</section>
	);
};

export default Hero;
